import { useLocation } from 'react-router-dom';

export default () => !useLocation().pathname.startsWith('/new_lms/manage');
